<div class="quicksearch--simple mb-0100">
    <mat-form-field class="col__ ongray quicksearch--simple__input" [ngClass]="{ 'loading': loading }">
        <mat-label>Search fields &amp; responses</mat-label>
        <mat-icon matIconPrefix
                  fontSet="far fa-fw"
                  fontIcon="fa-magnifying-glass"
                  class="color--gray--007"
                  *ngIf="!loading"></mat-icon>
        <mat-icon matIconPrefix
                  fontSet="far fa-fw"
                  fontIcon="fa-spinner"
                  class="color--gray--007 fa-spin"
                  *ngIf="loading"></mat-icon>
        <input matInput
               type="search"
               name="new-password"
               autocomplete="off"
               [matAutocomplete]="auto"
               [formControl]="searchInput">
    </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete"
                      [displayWith]="displayWithFn"
                      (optionSelected)="onResultSelected($event)">
        <mat-option *ngFor="let result of searchResults$ | async"
                    [value]="result">
            <ng-container *ngIf="result.type === 'Tag'">
                <span> {{result.groupName}} > </span>
                <span [innerHtml]="result.categoryName | highlightText : searchInput.value"> </span> >
                <span [innerHtml]="result.tagName | highlightText : searchInput.value"></span>
            </ng-container>
            <ng-container *ngIf="result.type === 'TagCategory'">
                <span> {{result.groupName}} > </span>
                <span [innerHtml]="result.categoryName | highlightText : searchInput.value"> </span>
            </ng-container>
        </mat-option>

    </mat-autocomplete>
</div>
